import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";

var TaskHelper =
/*#__PURE__*/
function () {
  function TaskHelper() {
    _classCallCheck(this, TaskHelper);
  }

  _createClass(TaskHelper, [{
    key: "selectProperty",
    value: function selectProperty(task, propertyId) {
      var route = null;

      switch (task) {
        case "Occupancy":
          route = "occupancy/list/project";
          break;

        case "Utility Allowance":
          route = "utilityAllowance/list/project";
          break;

        case "Budget":
          route = "budgetlist";
          break;
      }

      return "/".concat(route, "/").concat(propertyId);
    }
  }]);

  return TaskHelper;
}();

export default new TaskHelper();